
import Note from "../../../assets/duotone/Note.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteIcon({ className, dataTestid = "NoteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Note data-testid={dataTestid} className={classes} {...rest} />
  );
}
